import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  alpha,
} from '@mui/material';
import BaseTab from './BaseTab';

interface BackendAPIEndpointsTabProps {
  isDark: boolean;
  colors: any;
  discordFont: any;
  glassStyle: any;
  lokiGradient: string;
  goldColor: string;
  isMobile: boolean;
}

const BackendAPIEndpointsTab: React.FC<BackendAPIEndpointsTabProps> = (props) => {
  const getColor = (index: number) => {
    const colors = [props.goldColor, '#0F3B2E', '#1D5C4A', '#051814', props.goldColor, '#0F3B2E', '#1D5C4A', '#051814'];
    return colors[index % colors.length];
  };

  return (
    <BaseTab
      {...props}
      title="Backend API Endpoints"
      emoji="📡"
    >
      <Typography variant="h6" sx={{ color: props.goldColor, mb: 3 }}>
        Comprehensive API Reference
      </Typography>

      <Grid container spacing={3}>
        {[
          {
            category: 'Authentication',
            endpoints: [
              'POST /api/auth/register',
              'POST /api/auth/login',
              'GET /api/auth/google',
              'GET /api/auth/me',
            ],
          },
          {
            category: 'Users',
            endpoints: [
              'GET /api/user/profile/:username',
              'PUT /api/user/profile',
              'GET /api/user/search',
            ],
          },
          {
            category: 'Communities',
            endpoints: [
              'GET /api/community',
              'POST /api/community',
              'GET /api/community/:slug',
              'PUT /api/community/:id/edit',
            ],
          },
          {
            category: 'Posts',
            endpoints: [
              'GET /api/posts',
              'POST /api/posts',
              'GET /api/posts/:id',
              'GET /api/posts/user/feed',
            ],
          },
          {
            category: 'Chat',
            endpoints: [
              'GET /api/chat/messages',
              'POST /api/chat/messages',
              'POST /api/chat/upload',
              'GET /api/chat/giphy/search',
            ],
          },
          {
            category: 'Explore',
            endpoints: [
              'POST /api/explore/search',
              'POST /api/explore/geocode',
              'POST /api/explore/visits',
              'GET /api/explore/visits/history',
            ],
          },
          {
            category: 'Admin',
            endpoints: [
              'GET /api/admin/stats',
              'GET /api/admin/users',
              'PUT /api/admin/users/:id/role',
              'GET /api/admin/reports',
            ],
          },
          {
            category: 'System',
            endpoints: [
              'GET /health',
              'GET /api/chat/ws-test',
              'GET /debug-env',
            ],
          },
        ].map((api, idx) => (
          <Grid size={{ xs: 12, md: 6 }} key={idx}>
            <Card sx={{ borderLeft: `4px solid ${getColor(idx)}`, height: '100%' }}>
              <CardContent>
                <Typography variant="h6" sx={{ color: getColor(idx), mb: 2 }}>
                  {api.category}
                </Typography>
                <List dense>
                  {api.endpoints.map((endpoint, eIdx) => (
                    <ListItem key={eIdx} sx={{ py: 0.5 }}>
                      <ListItemText
                        primary={endpoint}
                        primaryTypographyProps={{
                          variant: 'body2',
                          fontFamily: 'monospace',
                          color: props.colors.textPrimary,
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </BaseTab>
  );
};

export default BackendAPIEndpointsTab;